import { render, staticRenderFns } from "./PActionsFloat.vue?vue&type=template&id=d6cc45f4&scoped=true"
import script from "./PActionsFloat.vue?vue&type=script&lang=ts"
export * from "./PActionsFloat.vue?vue&type=script&lang=ts"
import style0 from "./PActionsFloat.vue?vue&type=style&index=0&id=d6cc45f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6cc45f4",
  null
  
)

export default component.exports